<template>
  <div class="m-content content">
    <div v-show="isShowScanning">
      <img :src="pcLogin" alt="index" class="indexImg" @click="isShowScanning = false"/>
    </div>
    <div v-show="!isShowScanning">
      <!-- 首图 -->
      <div class="container">
        <img src="https://sys.rennengda.com/public/images/activtiesImage.png" alt="image" class="homeImg" />
        <p class="descTitle">线上生涯驿站</p>
      </div>
      <!-- 二维码 -->
      <el-card shadow="always" class="card">
        <div id="login_container"></div>
      </el-card>
    </div>
  </div>
</template>

<script>
import setWechatTitle from "@/utils/setWechatTitle.js";
export default {
  data() {
    return {
      isShowScanning: true,
      p: ''
    };
  },
  created() {
    setWechatTitle("微信登录");
  },
  computed: {
    pcLogin() {
      return 'http://sys.rennengda.com/weekon/cos/images/splash-' + this.p + '.jpg'
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.p = urlParams.get('p');
    this.scanning(this.p)
  },
  methods: {
    viewScanning() {
      this.isShowScanning = false
    },
    scanning(p) {
      const obj = new WxLogin({
      self_redirect: false,
      id: "login_container",
      appid: "wx116876931d84cf08",
      scope: "snsapi_login",
      redirect_uri: encodeURIComponent(`https://wx.rennengda.com/cos/?p=${p}`),
      // redirect_uri: encodeURIComponent('http://rnd.nat300.top/cos/?p=rnd'),
      state: "scanning_state",
      style: "black",
      href: ""
    });
    }
  }
};
</script>


<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.8rem 0;
  position: relative;
}

.content {
  overflow: hidden;
}

.homeImg {
  width: 93%;
  margin: 0 auto;
}

.descTitle {
  color: #fff;
  font-weight: 550;
  font-size: 0.5rem;
  position: absolute;
  top: 0.7rem;
  letter-spacing: 0.1rem;
}

.card {
  width: 93%;
  margin: 0 auto;
  text-align: center;
}

.indexImg {
  width: 100%;
  height: auto;
}

.card-Titlt {
  font-weight: 550;
  font-size: 0.35rem;
  text-align: left;
}

.card-annotation {
  font-size: 0.3rem;
}
</style>